import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Gets warnings whenever the parent collection context changes.
 */
export const loadForCurrentEntityOnContextChange = store.effects.create(
  <TTypeParams extends ec.models.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    plugin.collection.feature.actions.changeContext
      .observe()
      .pipe(
        rxjs.map(() =>
          feature.actions.loadForCurrentEntity.request
            .from('(effect) load for current entity on context change')
            .create(),
        ),
      ),
)
